import React, { FC } from 'react'

import { FormSelectProps } from '../form/FormSelect'

import * as SC from './styled'

export type HeaderProps = {
  className?: string
  localeSelect?: FormSelectProps
}

const Header: FC<HeaderProps> = (props) => {
  const { className, localeSelect } = props

  return (
    <SC.Header className={className}>
      <SC.SLogo />
      {localeSelect && <SC.LanguageSelector {...localeSelect} uppercaseOptions />}
    </SC.Header>
  )
}

export default Header
